import script from "./UserNav.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNav.vue?vue&type=script&setup=true&lang=js"

import "./UserNav.vue?vue&type=style&index=0&id=92ce82a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92ce82a6"]])

export default __exports__